export default __webpack_public_path__ + "static/media/logo-full.fdb03a4f.png";